class CustomSwatches extends HTMLElement {
  constructor() {
    super();
    this.swatches = this.querySelectorAll(".custom-swatch");
    this.handleSwatchClick = this.handleSwatchClick.bind(this);
  }

  connectedCallback() {
    this.swatches.forEach((swatch) => {
      swatch.addEventListener("click", this.handleSwatchClick);
    });
  }

  disconnectedCallback() {
    this.swatches.forEach((swatch) => {
      swatch.removeEventListener("click", this.handleSwatchClick);
    });
  }

  handleSwatchClick(e) {
    const container = e.target.closest(".custom-swatch");
    const handle = container.dataset.handle;

    this.fetchSections(window.Shopify.routes.root + `products/${handle}`);
  }

  fetchSections(url) {
    try {
      fetch(url)
        .then((response) => {
          return response.text();
        })
        .then((text) => {
          const html = new DOMParser().parseFromString(text, "text/html");
          const new_form = html.querySelector("product-form");
          console.log("HTML -> ", new_form);
          this.replaceSections(html);
        });
    } catch (error) {
      console.log("ERROR GETTING PRODUCT DATA -> ", error);
    }
  }

  replaceSections(html) {
    const oldSection = document.querySelector(".mount-product-page");
    const newSection = html.querySelector(".mount-product-page");

    oldSection.replaceWith(newSection);
  }
}

if (!customElements.get("custom-swatches")) {
  customElements.define("custom-swatches", CustomSwatches);
}
